import { PrismicRichText, PrismicText } from '@prismicio/react'
import _ from 'lodash'
import { InfoPanel } from '.'
import CloseButton  from '../assets/images/icons/close-button.svg'

interface MegaNavProps {
    core?: any | null;
    sections?: any | null;
    setMenuState?: any | null;
}

const MegaNav:React.FC<MegaNavProps>  =({ core, sections, setMenuState })=> {

    const tagSet=[] as any
    const tagOrder=[] as any

    sections.map((item: any)=>{
      if(item.tags.length > 0) {
        item.tags.map((tag: any)=>{
          tagSet.push(tag)
        })
      }
      return null
    })

    const cleanedTags = _.uniq(tagSet)

    let infoPages=[] as any
    let infoText = ""  as any

    core.data.slices.map((item: any)=>{
      if(item.slice_type === "mega_nav") {
        infoPages = item.primary.tags;
        infoText = item.primary;
      }
      return null
    })

    infoPages.map((heading: any) => {
      cleanedTags.map((tag: any)=>{
        if(heading.tag_name === tag) {
          tagOrder.push(tag)
        }
        return null
      })
      return null
    });

    const finalTags = _.uniq(tagOrder)

  return (
    <div className="w-full bg-jade fixed top-0 h-screen left-0 z-[100] font-fellix text-white overflow-y-scroll">
      <div className="max-w-[1180px] mx-auto relative py-12 px-4 xl:px-0">
        <button
          type="button"
          aria-label="Close menu"
          className="absolute right-4 xl:right-0 min-w-[44px] min-h-[44px] flex items-center justify-center duration-500 hover:opacity-60 cursor-pointer bg-transparent border-0 p-0"
          onClick={()=>{setMenuState(false); document.body.style.overflow="visible"}}
        ><CloseButton/></button>
        <div className="grid grid-cols-12 mt-16 gap-0 md:gap-x-16 lg:gap-x-24">
          {sections.map((item: any, itemIndex: number)=>{
            if(item.tags.indexOf("MegaNav Button") >-1) {
              return (
                <div className="col-span-12 md:col-span-4 mb-8 md:mb-0" key={itemIndex}>
                  <a className="border-[1px] border-white rounded-full text-white w-full inline-block py-4 px-8 text-center text-[18px] leading-[18px]" href={"/" + item.uid} ><PrismicText field={item.data.page_title}/></a>
                </div>
              )
            }
          })}
        </div>
        <div className="grid grid-cols-12 gap-0 md:gap-x-16 lg:gap-x-24">
            {finalTags.map((tag: any, tagItems: number)=> {
              return (
                <div className="col-span-12 md:col-span-4 border-t-[1px] border-t-white mt-16 text-[18px]" key={tagItems}>
                  <h3 className="my-5 text-[28px] font-semibold">{tag}</h3>
                    <ul>
                      {sections.map((item: any, tagIndex: number)=>{
                        if(item.tags.indexOf(tag)>-1) {
                          return (
                             <li key={tagIndex}><a href={"/"+item.uid} className="flex min-h-[44px] items-center"><PrismicText field={item.data.page_title}/></a></li>
                          )
                        }
                      })}
                    </ul>
                </div>
              )
            })}
        </div>
      </div>
      <div className="bg-deepjade">
        <div className="grid grid-cols-12 mt-16 py-4 max-w-[1180px] mx-auto px-4 xl:px-0  gap-0 md:gap-x-16 lg:gap-x-24">
            <div className="col-span-12 md:col-span-4 text-[18px] pr-[50%] my-8 md:my-0">
              <PrismicRichText field={infoText.learn_more_text}/>
            </div>
            <div className="col-span-12 md:col-span-7">
              <div className="grid grid-cols-12 gap-x-4">
                {infoText.learn_more_page_one && infoText.learn_more_page_one.uid ? 
                <div className="col-span-12 md:col-span-4">
                    <InfoPanel data={infoText.learn_more_page_one.uid} /> 
                </div>
                : null }
                {infoText.learn_more_page_two && infoText.learn_more_page_two.uid ? 
                <div className="col-span-12 md:col-span-4">
                    <InfoPanel data={infoText.learn_more_page_two.uid} /> 
                </div>
                : null }
                {infoText.learn_more_page_three && infoText.learn_more_page_three.uid ? 
                <div className="col-span-12 md:col-span-4">
                    <InfoPanel data={infoText.learn_more_page_three.uid} /> 
                </div>
                : null }
              </div>
            </div>
          </div>
        </div>
    </div>
  )
}

export default MegaNav
